module.exports = __webpack_public_path__ + "static/media/IMG-6541.44964cd3.jpg";